/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/help': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11.258-3.976a2 2 0 00-2.225 1.308 1 1 0 01-1.887-.664 4 4 0 017.774 1.333c0 1.53-1.135 2.54-1.946 3.081-.38.254-.755.449-1.054.587v.831a1 1 0 11-2 0V13a1 1 0 01.682-.948l.016-.006a5.763 5.763 0 00.364-.147 6.04 6.04 0 00.883-.481c.69-.46 1.055-.949 1.055-1.418v-.002a2 2 0 00-1.662-1.974zM12 16a1 1 0 100 2h.01a1 1 0 100-2H12z" _fill="currentColor"/>'
  }
})
